export default __webpack_public_path__ + "envision-icons.svg";